import React from "react";
import { Info, MessageSquareMore, Code2, CalendarClock } from "lucide-react";

export default function Versao1020() {
  return (
    <div className="space-y-8">
      <h1 className="text-xl font-semibold text-green-700">
        Melhorias da Versão 1.0.20
      </h1>

      {/* Ajuste no Chat Interno */}
      <div className="flex items-start gap-3">
        <MessageSquareMore className="text-purple-500 mt-1" size={20} />
        <div>
          <h2 className="font-semibold text-gray-800">Ajuste no Chat Interno:</h2>
          <p className="text-gray-700">
            Problema de duplicação de mensagens totalmente resolvido. Agora as mensagens são exibidas apenas uma vez,
            mesmo com atualização em tempo real.
          </p>
          <p className="text-gray-500 text-sm mt-1">
            O sistema agora identifica corretamente mensagens temporárias e evita repetições do banco de dados.
          </p>
        </div>
      </div>

      {/* Estabilidade e limpeza de código */}
      <div className="flex items-start gap-3">
        <Code2 className="text-red-500 mt-1" size={20} />
        <div>
          <h2 className="font-semibold text-gray-800">Estabilidade e limpeza de código:</h2>
          <p className="text-gray-700">
            A lógica de sincronização e envio de mensagens foi otimizada, garantindo funcionamento mais estável,
            rápido e sem inconsistências.
          </p>
        </div>
      </div>

      {/* Preparação para novas melhorias */}
      <div className="flex items-start gap-3">
        <Info className="text-gray-700 mt-1" size={20} />
        <div>
          <h2 className="font-semibold text-gray-800">Preparação para novas melhorias:</h2>
          <p className="text-gray-700">
            Código do módulo de Chat Interno revisado e preparado para receber novas funcionalidades nas próximas versões.
          </p>
        </div>
      </div>

      {/* Box de aviso */}
      <div className="p-4 rounded-md border border-blue-300 bg-blue-50 flex items-start gap-3">
        <CalendarClock size={18} className="text-blue-600 mt-1" />
        <p className="text-blue-700 text-sm">
          <strong>Próximas Atualizações</strong> <br />
          A versão 1.0.21 trará melhorias gerais no Chat Interno e vamos adicionar notificação de mensagens.
        </p>
      </div>
    </div>
  );
}
